import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Droplets, Globe2, Plane, Award, GraduationCap, Plus, Minus } from 'lucide-react';
import { DiveMaskIcon } from './DiveMaskIcon';
const items = [{
  icon: BookOpen,
  title: 'Material digital oficial PADI',
  contenido: ['Trabajamos exclusivamente con materiales oficiales y originales de PADI.', 'Tendrás acceso al sistema educativo utilizado por millones de buzos en todo el mundo.', 'No utilizamos copias, resúmenes ni archivos PDF no oficiales.', 'Aprenderás con el mismo material que utilizan los centros PADI internacionales.']
}, {
  icon: DiveMaskIcon,
  title: 'Equipo completo incluido',
  contenido: ['Todos nuestros programas incluyen el equipamiento necesario para realizar las prácticas del curso.', 'No necesitás comprar equipo para comenzar.', 'Te proporcionamos el material requerido para entrenar de forma cómoda y segura durante todas las actividades prácticas.', 'Nuestro objetivo es que te concentres en aprender a bucear, no en preocuparte por el equipamiento.']
}, {
  icon: Droplets,
  title: 'Entrenamiento en piscina',
  contenido: ['Contarás con 5 clases de entrenamiento en piscina especialmente diseñadas para desarrollar tus habilidades como buzo.', 'Cada encuentro combina teoría y práctica para que avances de manera progresiva y segura.', 'Las clases teóricas tienen una duración aproximada de 1 hora.', 'Las clases prácticas tienen una duración aproximada de 1 hora.', 'Durante estas sesiones aprenderás las técnicas fundamentales que luego aplicarás en aguas abiertas.']
}, {
  icon: Globe2,
  title: 'Certificación internacional PADI',
  contenido: ['PADI es la organización de entrenamiento de buceo más reconocida y respetada del mundo.', 'Al completar tu formación obtendrás una certificación internacional utilizada por millones de buzos en más de 180 países.', 'Tu credencial te permitirá bucear en centros de buceo de todo el mundo, alquilar equipamiento, participar en excursiones y continuar tu formación con niveles más avanzados.', 'Cuando obtenés tu certificación PADI no solamente aprendés a bucear.', 'Obtenés acceso a una comunidad global de exploradores, viajeros y amantes del océano.']
}, {
  icon: Plane,
  title: 'Completá tus aguas abiertas donde quieras',
  contenido: ['Una de las mayores ventajas del sistema PADI es su flexibilidad.', 'Podés realizar toda tu formación teórica y práctica en piscina con nosotros y completar tus inmersiones de certificación en cualquier centro PADI del mundo.', 'Una vez finalizada la etapa de entrenamiento en piscina, tu formación tiene una validez de hasta 1 año para completar las aguas abiertas.', 'Muchos alumnos aprovechan sus vacaciones para terminar su certificación en destinos de buceo increíbles alrededor del mundo.', 'Si lo necesitás, también podemos ayudarte a elegir un centro PADI de confianza para completar tu entrenamiento o participar de alguno de nuestros viajes grupales nacionales e internacionales.', 'El objetivo es que puedas certificarte de la manera que mejor se adapte a tus planes y estilo de viaje.']
}, {
  icon: Award,
  title: 'Tu certificación es solo el comienzo',
  contenido: ['Convertirte en Open Water Diver es el primer paso dentro del mundo del buceo.', 'Una vez certificado podrás participar en viajes de buceo, explorar nuevos destinos, descubrir arrecifes, naufragios y continuar avanzando con certificaciones superiores.', 'Muchos de nuestros alumnos comienzan con su Open Water Diver y terminan recorriendo algunos de los mejores destinos de buceo del planeta.', 'Tu primera certificación abre la puerta a experiencias que recordarás toda la vida.']
}, {
  icon: GraduationCap,
  title: 'Entrenamiento personalizado',
  contenido: ['Cada alumno aprende a un ritmo diferente.', 'Por eso ofrecemos entrenamiento personalizado y horarios flexibles durante toda la semana.', 'No dependés de grupos mínimos para comenzar ni de fechas únicas de inicio.', 'Una vez inscripto recibirás las opciones de horarios disponibles para que puedas organizar tu formación de acuerdo a tu disponibilidad.', 'Nuestro objetivo es que aprendas con confianza, seguridad y sin presiones innecesarias.']
}];
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 sm:py-24 px-6 bg-brand-background relative" data-id="element-276">
      <div className="max-w-3xl mx-auto" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 sm:mb-14" data-id="element-278">
          <h3 className="text-brand-primary font-heading font-bold text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight" data-id="element-279">
            ¿Qué incluye tu curso?
          </h3>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-280">
          {items.map((item, index) => {
          const isOpen = openIndex === index;
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} className={`rounded-2xl border bg-brand-dark overflow-hidden transition-colors ${isOpen ? 'border-brand-primary/50' : 'border-brand-primary/20'}`} data-id="element-281">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-center gap-4 p-5 sm:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary/60 rounded-2xl" data-id="element-282">
                  <span className="w-12 h-12 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary shrink-0" data-id="element-283">
                    <Icon size={24} strokeWidth={1.5} data-id="element-284" />
                  </span>
                  <span className="flex-grow text-white font-bold text-lg sm:text-xl" data-id="element-285">
                    {item.title}
                  </span>
                  <span className="text-brand-primary shrink-0" data-id="element-286">
                    {isOpen ? <Minus size={22} data-id="element-287" /> : <Plus size={22} data-id="element-288" />}
                  </span>
                </button>

                <AnimatePresence initial={false} data-id="element-289">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-290">
                      <div className="px-5 sm:px-6 pb-6 pl-[4.25rem] sm:pl-[5.5rem] space-y-3 text-white/70 leading-relaxed" data-id="element-291">
                        {item.contenido.map((p, i) => <p key={i} data-id="element-292">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}